import { ArtistAnalyticsState } from './state';

import ExampleData from './example-data.json';
import { AnalyticsResults } from '@services/analytics/types/analytics-results';

const today = Number(new Date()) / 1000;
const defaultOffset = 30 * 24 * 60 * 60;

export const artistAnalyticsInitialState: ArtistAnalyticsState = {
  data: ExampleData as unknown as AnalyticsResults,
  isExample: true,
  filters: {
    date: '',
    dsps: [],
    // startDate:"",
    // endDate:"",
    range: 'lastMonth',
    days: '30',
  },
  timeframe: {
    start: today - defaultOffset,
    end: today,
  },
  lastMonthAnalytics: {
    timeseries: [],
    change: 0,
    percentChange: 0,
  },
};
